var map = {
	"./allium.png": "f69b",
	"./apple.png": "9c48",
	"./arrow.png": "d27f",
	"./azure_bluet.png": "85c8",
	"./bamboo.png": "f77e",
	"./ban_hammer.png": "b5fb",
	"./banana.png": "d512",
	"./blaze_rod.png": "a06f",
	"./blue_orchid.png": "be55",
	"./bone.png": "7f99",
	"./bow.png": "aab0",
	"./cake_inner.png": "4d18",
	"./cake_side.png": "87f8",
	"./cookie.png": "838f",
	"./cornflower.png": "db55",
	"./dandelion.png": "6a7a",
	"./diamond_axe.png": "dd39",
	"./diamond_hoe.png": "1981",
	"./diamond_pickaxe.png": "5908",
	"./diamond_shovel.png": "a593",
	"./diamond_sword.png": "6090",
	"./golden_apple.png": "0e6c",
	"./golden_axe.png": "bc62",
	"./golden_carrot.png": "a138",
	"./golden_hoe.png": "5380",
	"./golden_pickaxe.png": "a1a3",
	"./golden_shovel.png": "b9e0",
	"./golden_sword.png": "7d33",
	"./heart.png": "2978",
	"./iron_axe.png": "56bf",
	"./iron_hoe.png": "d1c7",
	"./iron_pickaxe.png": "b166",
	"./iron_shovel.png": "9c82",
	"./iron_sword.png": "c6a6",
	"./lilac_top.png": "70e6",
	"./lily_of_the_valley.png": "f463",
	"./name_tag.png": "f552",
	"./netherite_axe.png": "f969",
	"./netherite_hoe.png": "76b6",
	"./netherite_pickaxe.png": "e67b",
	"./netherite_shovel.png": "5a85",
	"./netherite_sword.png": "1303",
	"./orange_tulip.png": "41db",
	"./oxeye_daisy.png": "6883",
	"./peony_top.png": "5df6",
	"./pink_tulip.png": "8332",
	"./poppy.png": "ed2d",
	"./pufferfish.png": "78e9",
	"./pufferfish_bucket.png": "2555",
	"./red_tulip.png": "aec4",
	"./redstone_torch.png": "4a14",
	"./rose_bush_top.png": "76da",
	"./salmon.png": "de55",
	"./shears.png": "430a",
	"./spectral_arrow.png": "8d8e",
	"./spyglass.png": "c4e2",
	"./stick.png": "1b35",
	"./stone_axe.png": "1f8d",
	"./stone_hoe.png": "747a",
	"./stone_pickaxe.png": "c610",
	"./stone_shovel.png": "52a9",
	"./stone_sword.png": "759e",
	"./totem_of_undying.png": "2225",
	"./trident.png": "d7ac",
	"./wheat.png": "5e3a",
	"./white_tulip.png": "158c",
	"./wither_rose.png": "c893",
	"./wooden_axe.png": "0164",
	"./wooden_hoe.png": "c47e",
	"./wooden_pickaxe.png": "5e7d",
	"./wooden_shovel.png": "19a8",
	"./wooden_sword.png": "7126",
	"./writable_book.png": "32a4",
	"./written_book.png": "762b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a067";